import { useEffect, useState } from 'react';

export default (ref) => {
  const [hover, setHover] = useState(false);
  const [hovered, setHovered] = useState(false);

  const onMouseEnter = () => {
    setHover(true);
    setHovered(true);
  };

  const onMouseLeave = () => {
    setHover(false);
  };

  useEffect(() => {
    if (ref.current) {
      ref.current.addEventListener('mouseenter', onMouseEnter);
      ref.current.addEventListener('mouseleave', onMouseLeave);
    }
    return () => {
      if (ref.current) {
        ref.current.removeEventListener('mouseenter', onMouseEnter);
        ref.current.removeEventListener('mouseleave', onMouseLeave);
      }
    };
  }, []);

  return [hover, hovered];
};
